class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.cachedTotalResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.totalCountAbortController = new AbortController();
    this.totalCountTimer = null;
    this.searchTerm = '';
    this.quickSearchTrending = this.querySelectorAll('.quickSearchTrending .link');
    this.searchResultsWidget = this.getElementsByClassName('quickSearchResultsWidget')[0];

    // Some legacy header snippets force every submitted search to products only.
    // Removing that override lets Shopify's Search & Discovery settings decide
    // which resource types appear on the full results page.
    this.input.form
      .querySelectorAll('input[name="type"][value="product"]')
      .forEach((input) => input.remove());

    this.setupEventListeners();
    this.quickSearchTrending.forEach(element => {
      element.addEventListener('click', this.quickSearchTrendingClick.bind(this));
    });
  }
  
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    document.addEventListener('click', this.onDocClick.bind(this));
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
  }

  handleResponse(data,limit) {
    let htmlMedia = document.createElement('div');
    htmlMedia.innerHTML = data;

    $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();
    return $(htmlMedia).html();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      clearTimeout(this.totalCountTimer);
      this.totalCountAbortController.abort();
      this.totalCountAbortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return this.showTrendingAndProducts();

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  
  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
  
    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('[data-predictive-option]')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';
    
    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }
  
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.toLowerCase();
    this.setLiveRegionLoadingState();
    
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.updateViewAllLink(searchTerm, queryKey);
      return;
    }

    // Request a balanced set per resource type. The Liquid template controls
    // the visual priority and keeps each group intentionally compact.
    this.abortController.abort();
    this.abortController = new AbortController();

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=query,collection,product,article,page&resources[limit]=4&resources[limit_scope]=each`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        
        return response.text();
      })  
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
        this.updateViewAllLink(searchTerm, queryKey);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }
  
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.applyIntentRanking(this.searchTerm);
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
    if($('.dropdown-item[data-currency]').length){
      if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
      }
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
    if($('body').hasClass('product-card-layout-08')) {
      window.sharedFunctions?.productCountdownCard();
    }
  }

  normalizeIntentText(value) {
    return (value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => {
        if (word.length > 3 && word.endsWith('s') && !word.endsWith('ss')) {
          return word.slice(0, -1);
        }
        return word;
      })
      .join(' ');
  }

  applyIntentRanking(searchTerm) {
    const resultsContainer = this.querySelector('[data-predictive-mega]');
    if (!resultsContainer) return;

    const normalizedQuery = this.normalizeIntentText(searchTerm);
    if (!normalizedQuery) return;

    const collectionGroup = resultsContainer.querySelector('[data-predictive-collection-group]');
    const articleGroup = resultsContainer.querySelector('[data-predictive-article-group]');
    const pageGroup = resultsContainer.querySelector('[data-predictive-page-group]');

    let exactCollectionLink = null;
    if (collectionGroup) {
      const collectionLinks = collectionGroup.querySelectorAll('[data-predictive-collection-link]');
      exactCollectionLink = Array.from(collectionLinks).find((link) => {
        const collectionTitle = link.dataset.collectionTitle || link.textContent;
        return this.normalizeIntentText(collectionTitle) === normalizedQuery;
      }) || null;
    }

    // Keep products in the main merchandising area, but make an exact
    // collection match unmistakable and move it to the top of the side rail.
    if (exactCollectionLink && collectionGroup) {
      resultsContainer.classList.add('has-collection-intent');
      collectionGroup.classList.add('is-best-match');
      const resultType = exactCollectionLink.querySelector('.ee-predictive-type');
      const exactCollectionItem = exactCollectionLink.closest('li');
      const collectionList = exactCollectionLink.closest('[data-predictive-collection-list]');
      exactCollectionLink.classList.add('is-exact-match');
      if (resultType) resultType.textContent = 'Best match';
      if (exactCollectionItem && collectionList) {
        collectionList.insertBefore(exactCollectionItem, collectionList.firstElementChild);
      }
      return;
    }

    const informationalIntent = /^(how|what|which|why|when|where)\b|\b(guide|care|size|sizes|difference|differences|meaning|history|instruction|instructions|idea|ideas)\b/.test(normalizedQuery);

    // For research-led searches, retain the predictable two-column layout but
    // visually prioritise the most useful supporting content in the side rail.
    if (informationalIntent && (articleGroup || pageGroup)) {
      resultsContainer.classList.add('has-information-intent');
      articleGroup?.classList.add('is-priority-result');
      pageGroup?.classList.add('is-priority-result');
      return;
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  
  getResultsMaxHeight() {
    if (window.innerWidth > 1024) {
      const resultsTop = Math.round(this.input.getBoundingClientRect().bottom + 18);
      this.resultsMaxHeight = Math.max(360, window.innerHeight - resultsTop - 16);
      return this.resultsMaxHeight;
    }

    const headerNavigation = document.querySelector('[class^="header-navigation"]');
    const headerBottom = headerNavigation ? headerNavigation.getBoundingClientRect().bottom : 0;
    this.resultsMaxHeight = Math.max(320, window.innerHeight - headerBottom);
    return this.resultsMaxHeight;
  }
  
  open() {
    if (window.innerWidth > 1024) {
      const inputRect = this.input.getBoundingClientRect();
      const dropdownTop = Math.max(0, Math.round(inputRect.bottom + 18));
      this.predictiveSearchResults.style.setProperty('--ee-predictive-top', `${dropdownTop}px`);
    } else {
      this.predictiveSearchResults.style.removeProperty('--ee-predictive-top');
    }

    this.predictiveSearchResults.style.maxHeight = `${this.getResultsMaxHeight()}px`;

    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  updateViewAllLink(searchTerm, queryKey = searchTerm.toLowerCase()) {
    const qsViewAllLink = this.querySelector('[data-qs-view-all-link]');
    const productsViewAllLink = this.querySelector('[data-qs-products-view-all-link]');
    if (!qsViewAllLink && !productsViewAllLink) return;

    // Do not add `type=product`: omitting it honours the resource types enabled
    // in Shopify Search & Discovery (products, pages and blog posts).
    const searchUrl = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&options%5Bprefix%5D=last`;
    if (qsViewAllLink) qsViewAllLink.href = searchUrl;
    if (productsViewAllLink) productsViewAllLink.href = searchUrl;

    if (!qsViewAllLink) return;

    const label = qsViewAllLink.querySelector('[data-qs-view-all-text]');
    if (label) label.textContent = 'View all results';

    clearTimeout(this.totalCountTimer);
    this.totalCountAbortController.abort();
    this.totalCountAbortController = new AbortController();

    if (Number.isFinite(this.cachedTotalResults[queryKey])) {
      this.applyTotalResultCount(this.cachedTotalResults[queryKey]);
      return;
    }

    const signal = this.totalCountAbortController.signal;
    this.totalCountTimer = setTimeout(() => {
      this.getTotalResultCount(searchUrl, signal)
        .then((count) => {
          this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedTotalResults[queryKey] = count;
          });
          this.cachedTotalResults[queryKey] = count;

          if (this.searchTerm.toLowerCase() === queryKey) {
            this.applyTotalResultCount(count);
          }
        })
        .catch((error) => {
          if (error?.name !== 'AbortError') {
            // Keep the useful fallback label if the optional count request fails.
            return;
          }
        });
    }, 300);
  }

  applyTotalResultCount(count) {
    const label = this.querySelector('[data-qs-view-all-text]');
    if (!label) return;

    const resultCount = Number(count);
    label.textContent = resultCount > 0
      ? `View all ${new Intl.NumberFormat().format(resultCount)} results`
      : 'View all results';
  }

  getTotalResultCount(searchUrl, signal) {
    return fetch(searchUrl, { signal })
      .then((response) => {
        if (!response.ok) throw new Error(`Search count request failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const documentFromResponse = new DOMParser().parseFromString(text, 'text/html');
        const searchSection = documentFromResponse.querySelector('[id^="SearchSection-"][data-search-count]');
        if (!searchSection) throw new Error('Search count was not found in the response.');

        const count = Number(searchSection.dataset.searchCount);
        if (!Number.isFinite(count)) throw new Error('Search count was invalid.');
        return count;
      });
  }

  quickSearchTrendingClick(event) {
    window.location = event.currentTarget.getAttribute('href');
  }
}

customElements.define('predictive-search', PredictiveSearch);